import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  Injector,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { DrawerRef, DrawerService } from '@siat-fe/layout';

/**
 * Container component that dynamically loads components in the drawer
 */
@Component({
  selector: 'siat-drawer-container',
  imports: [CommonModule],
  template: `
    <div class="drawer-content pt-4">
      <ng-container #container></ng-container>
    </div>
  `,
  styles: [
    `
      .drawer-content {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    `,
  ],
})
export class DrawerContainerComponent implements OnInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;

  private drawerService = inject(DrawerService);
  private injector = inject(Injector);

  ngOnInit(): void {
    this.loadComponent();
  }

  ngOnDestroy(): void {
    this.container.clear();
  }

  /**
   * Loads the component dynamically in the container
   */
  private loadComponent(): void {
    const content = this.drawerService.component();
    const drawerRef = this.drawerService.drawerRef();
    const data = this.drawerService.config()?.data;

    if (!content || !drawerRef) {
      return;
    }

    this.container.clear();

    if (content instanceof TemplateRef) {
      this.container.createEmbeddedView(content, {
        $implicit: data,
        drawerRef: drawerRef,
      });
    } else {
      const customInjector = Injector.create({
        parent: this.injector,
        providers: [{ provide: DrawerRef, useValue: drawerRef }],
      });

      this.container.createComponent(content, {
        injector: customInjector,
      });
    }
  }
}
